import styled from 'styled-components';

export const Container = styled.div`
  small {
    border: 1px solid #9e9e9e;
    border-radius: 5px;
    padding: 2px 10px;
    display: block;
    background-color: #fbfdff;
    font-style: italic;
    border-style: dashed;
  }

  button {
    color: #fff;
    background-color: #28c893;
    border-color: #28c893;
  }
`;
